module.exports = __webpack_public_path__ + "static/media/s20_cloudblue.3d085beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/s20/s20_cloudblue.png
// module id = 2145
// module chunks = 0